"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = void 0;
const react_1 = __importDefault(require("react"));
const Overlay = ({ children, show, onKeyDown, }) => (show ? (react_1.default.createElement("div", { role: "presentation", className: "sweet-alert-overlay", onKeyDown: onKeyDown }, children)) : (react_1.default.createElement("div", { role: "presentation", onKeyDown: (e) => onKeyDown(e) }, children)));
exports.Overlay = Overlay;
